import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  constructor() {}

  @Input() items: any[] = [];
  @Input() totalRows: number;
  @Input() loading = false;

  @Output() pageChange = new EventEmitter<number>();

  currentPage = 1;
  ngOnInit(): void {}
}
